import React from 'react';
import YetToBeImplemented from './YetToBeImplemented/YetToBeImplemented';

function MarketingTool1Modal() {
  return (
    <div>
      <YetToBeImplemented />
    </div>
  );
}

export default MarketingTool1Modal;
